import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const STORAGE_KEY = "blacpac_admin_token";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

export function useAdminAuth() {
  const [token, setTokenState] = useState(readStored());

  const setToken = (value) => {
    try {
      if (value) localStorage.setItem(STORAGE_KEY, value);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore quota/private-mode errors
    }
    setTokenState(value || "");
  };

  const client = useMemo(() => {
    if (!token) return null;
    return axios.create({
      baseURL: API,
      headers: { Authorization: `Bearer ${token}` },
    });
  }, [token]);

  return { token, setToken, client };
}

export function useQuotes(client) {
  const [state, setState] = useState({ data: [], loading: false, error: null });

  const fetchQuotes = useMemo(
    () => async () => {
      if (!client) return;
      queueMicrotask(() => setState((s) => ({ ...s, loading: true, error: null })));
      try {
        const res = await client.get("/quotes?limit=500");
        queueMicrotask(() => setState({ data: res.data || [], loading: false, error: null }));
      } catch (err) {
        const status = err?.response?.status;
        queueMicrotask(() =>
          setState({
            data: [],
            loading: false,
            error: status === 401 ? "unauthorised" : "error",
          })
        );
      }
    },
    [client]
  );

  useEffect(() => {
    if (!client) return;
    fetchQuotes();
  }, [client, fetchQuotes]);

  return { ...state, refetch: fetchQuotes };
}
